import {mergeAttributes, Node, wrappingInputRule} from "@tiptap/core";
import * as http from "http";

export interface BlockClassOptions {
    HTMLAttributes: Record<string, any>,
}

declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        blockClass: {
            /**
             * Set a blockquote node
             */
            setBlockClass: (blockClass: string) => ReturnType,
            /**
             * Toggle a blockquote node
             */
            toggleBlockClass: (blockClass: string) => ReturnType,
            /**
             * Unset a blockquote node
             */
            unsetBlockClass: (blockClass: string) => ReturnType,
        }
    }
}

export const inputBlockClassRegex = /^\s*>\s$/


export const BlockClass = Node.create<BlockClassOptions>({

    name: 'blockclass',

    addOptions() {
        return {
            HTMLAttributes: {},
        }
    },

    content: 'block+',

    group: 'block',

    defining: true,

    addAttributes() {
        return {
            blockClass: {
                default: 'block',
                rendered: false,
                parseHTML: element => {
                    return element.className;
                }
            }
        }
    },

    parseHTML() {
        return [
            { tag: 'div' },
        ]
    },

    renderHTML({node, HTMLAttributes }) {
        console.log("render:", HTMLAttributes, this.options);

        const c = node.attrs.blockClass ? node.attrs.blockClass : 'block';

        return ['div', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {'data-block': "1", 'class': c}), 0]
    },

    addCommands() {
        return {
            setBlockClass: (blockClass: string) => ({ commands }) => {
                return commands.wrapIn(this.name, {'blockClass': blockClass})
            },

            toggleBlockClass: (blockClass: string) => ({ commands }) => {
                return commands.toggleWrap(this.name, {'blockClass': blockClass})
            },

            unsetBlockClass: (blockClass: string) => ({ commands }) => {
                return commands.lift(this.name, {'blockClass': blockClass})
            },
        }
    },

    addKeyboardShortcuts() {
        return {
        }
    },

    addInputRules() {
        return [
            wrappingInputRule({
                find: inputBlockClassRegex,
                type: this.type,
            }),
        ]
    },
})